import axios from 'axios'

const onRequest = (config) => {
  config.headers.Authorization = `Bearer ${localStorage.accessToken}`
  return config
}

const onResponse = (response) => response
const onErrorResponse = (error) => {
  if (error.response === undefined)
    return Promise.reject('Ooops, algo anduvo mal por favor reintetar')
  else {
    // Don't handle 403 errors here - let global interceptor in App.vue handle them
    if (error.response.status === 403) {
      return Promise.reject(error)
    }
    return Promise.reject(error.response)
  }
}

const onErrorRequest = () => {
}

const ClientApiPrototype = function (url) {
  const axiosInstance = axios.create({
    baseURL: url
  })
  axiosInstance.interceptors.request.use(onRequest, onErrorRequest)
  axiosInstance.interceptors.response.use(onResponse, onErrorResponse)
  return axiosInstance
}

const ClientLambdaApi = ClientApiPrototype(process.env.API_LAMBDA_URL)
const ClientErAdminData = ClientApiPrototype(process.env.API_ER_ADMIN_DATA_URL)
const ClientBackGroundTasks = ClientApiPrototype(process.env.API_BACKGROUND_TASKS_URL)

const CustomClient = axios

export { ClientLambdaApi, CustomClient, ClientErAdminData, ClientBackGroundTasks}



// WEBPACK FOOTER //
// ./src/api-client.js